import React from 'react';

export default function({ color, width }) {
  if (color && width) {
    return (
      <style type="text/css">
        {`
        #gladlyChat_container .initialChatButton,
        #gladlyChat_container .minimizedChatButtonSelector,
        #gladlyChat_container .onboarding_selector,
        #gladlyChat_container .ongoingChat_selector {
          border-color: ${color} !important;
          border-style: solid !important;
          border-width: ${width} !important;
        }
      `}
      </style>
    );
  }
}
